import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { GlobalContext } from "../../context/GlobalContext";
import { ClientContext } from "../../context/Client/ClientContext";

const Header = () => {
  const location = useLocation();

  const { showLimitSearch, resetSearchByBtnState, resetGlobalState } =
    useContext(GlobalContext);

  const { hideClientList, clearCompanyNameSearch, resetClientContext } =
    useContext(ClientContext);

  const isLandingPage = location.pathname === "/";

  const resetToHome = () => {
    resetClientContext();
    showLimitSearch();
    resetSearchByBtnState();
    resetGlobalState();
    clearCompanyNameSearch();
    hideClientList();
  };

  const handleEnter = () => {
    window.localStorage.clear();
    resetGlobalState();
    resetClientContext();
    hideClientList();
  };

  return (
    <header className="gog-pro-header">
      <div className="gog-pro-header-inner">
        {/* BRAND */}
        <Link to="/" onClick={resetToHome} className="gog-pro-brand">
          <img src="/images/giveorgo-logo.png" alt="GiveOrGo Logo" />

          <div className="gog-pro-brand-copy">
            <strong>GiveOrGo</strong>
            <span>Give a Gift, or Go for a visit.</span>
          </div>
        </Link>

        {/* ACTIONS */}
        <nav className="gog-pro-nav" aria-label="Main navigation">
          {!isLandingPage && (
            <Link to="/" onClick={resetToHome} className="gog-pro-nav-link">
              Home
            </Link>
          )}

          {isLandingPage && (
            <Link
              to="/home"
              onClick={handleEnter}
              className="gog-pro-nav-link primary"
            >
              Enter Directory
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;